export default "__VITE_PUBLIC_ASSET__ca7099cb__"